// src/firebase.js
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCcglc9iqGydplqSyesRoF39bPvJI_T9EQ",
  authDomain: "reap-3f03d.firebaseapp.com",
  projectId: "reap-3f03d",
  storageBucket: "reap-3f03d.appspot.com",
  messagingSenderId: "664543936585",
  appId: "1:664543936585:web:a81d4be5b6a6d494403f98",
};
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

export {db}
// const firebaseConfig = {
//     apiKey: "AIzaSyCcglc9iqGydplqSyesRoF39bPvJI_T9EQ",
//     authDomain: "reap-3f03d.firebaseapp.com",
//     projectId: "reap-3f03d",
//     storageBucket: "reap-3f03d.appspot.com",
//     messagingSenderId: "664543936585",
//     appId: "1:664543936585:web:a81d4be5b6a6d494403f98",
//     measurementId: "G-4V9HSDMHQR",
//   };
